export const IS_PROD = process.env.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT === "production";
export const SHOULD_SKIP_AUTH_DEV = !IS_PROD && process.env.CLOUD_USES_TOKEN === "true";

export const CLOUD_TOKEN_PARAM_NAME = "token";
export const CLOUD_AUTH_HEADER_NAME = SHOULD_SKIP_AUTH_DEV ? "Authorization" : "X-FGSDK-TOKEN";
